module.exports = __webpack_public_path__ + "img/Bitfluent_Mockups@2x.14280307.png";